class SubCollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initializeWhenReady();
  }

  disconnectedCallback() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initializeWhenReady() {
    const swiperEl = this.querySelector('[data-sub-collection-swiper]');
    if (!swiperEl) return;

    if (typeof window.Swiper !== 'function') {
      window.requestAnimationFrame(() => this.initializeWhenReady());
      return;
    }

    const spaceBetweenMobile = Number(this.dataset.spaceBetweenMobile || 8);
    const spaceBetweenDesktop = Number(this.dataset.spaceBetweenDesktop || 12);
    const speed = Number(this.dataset.speed || 450);

    this.swiper = new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      freeMode: true,
      speed,
      spaceBetween: spaceBetweenMobile,
      breakpoints: {
        750: {
          spaceBetween: spaceBetweenDesktop
        }
      }
    });
  }
}

if (!customElements.get('sub-collection-slider')) {
  customElements.define('sub-collection-slider', SubCollectionSlider);
}
